export default __webpack_public_path__ + "static/media/m_special_picture_nome.204bbcc1.png";